export const getTeamData = ({ id = "", result: [{ data = {} }], status = "" }) => {
  if (status !== "teamSkills added") return null;

  return data;
};
